import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import QueryResponseForm from "./QueryResponseForm";
import { QueryDetailsModalProps } from "./type";

export default function QuerySubmitDetails({
  open,
  onClose,
  query,
  onSuccess,
}: QueryDetailsModalProps) {
  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "#111a39",
          color: "white",
        },
      }}
    >
      <DialogTitle sx={{ borderBottom: "1px solid #111a39" }}>
        Query Details
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        {query && (
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold mb-1">Question</h3>
              <p className="text-gray-300">{query.questionText}</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-1">Status</h3>
              <p className="text-gray-300">{query.status}</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-1">Date Submitted</h3>
              <p className="text-gray-300">
                {new Date(query.submittedDate).toLocaleDateString()}
              </p>
            </div>
            {query.status === "pending" && (
              <div>
                <h3 className="text-lg font-semibold mb-2">Submit Response</h3>
                <QueryResponseForm
                  queryId={query._id}
                  questionNumber={query.questionNumber}
                  onSuccess={handleSuccess}
                />
              </div>
            )}
            {query.status === "responded" && query.answer && (
              <div>
                <h3 className="text-lg font-semibold mb-1">Answer</h3>
                <p className="text-gray-300">{query.answer}</p>
              </div>
            )}
          </div>
        )}
      </DialogContent>
      <DialogActions sx={{ borderTop: "1px solid #333", p: 2 }}>
        <Button
          onClick={onClose}
          sx={{
            color: "white",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
